(() => {
  const config = window.YB_AUTO_LOCALIZATION || {};
  const country = String(config.currentCountry || '').toUpperCase();
  const countries = new Set((config.availableCountries || []).map((code) => String(code).toUpperCase()));
  const languages = new Set((config.availableLanguages || []).map((code) =>
    String(code).trim().replace(/_/g, '-').toLowerCase()));
  if (!/^[A-Z]{2}$/.test(country) || !countries.has(country)) return;

  const isLocale = (segment) => {
    const normalized = segment.toLowerCase();
    const routeCodes = new Set(languages);
    if (['zh', 'zh-cn', 'zh-hans'].some((code) => languages.has(code))) {
      ['zh', 'zh-cn', 'zh-hans'].forEach((code) => routeCodes.add(code));
    }
    if (['zh-tw', 'zh-hant'].some((code) => languages.has(code))) {
      ['zh-tw', 'zh-hant'].forEach((code) => routeCodes.add(code));
    }
    if (routeCodes.has(normalized)) return true;
    if (['zh', 'zh-cn', 'zh-hans', 'zh-tw', 'zh-hant'].includes(normalized)) return false;
    const baseMatches = [...languages].filter((code) => code.split('-')[0] === normalized);
    if (normalized !== 'zh' && baseMatches.length === 1) return true;
    return [...routeCodes].some((code) => {
      const prefixes = code.startsWith('zh') ? [code] : [code, code.split('-')[0]];
      for (const prefix of new Set(prefixes)) {
        if (!normalized.startsWith(`${prefix}-`)) continue;
        const suffix = normalized.slice(prefix.length + 1);
        if (/^[a-z]{2}$/.test(suffix) && countries.has(suffix.toUpperCase())) return true;
      }
      return false;
    });
  };

  const isProductPath = (pathname) => {
    const segments = pathname.split('/').filter(Boolean);
    if (isLocale(segments[0] || '')) segments.shift();
    const handle = segments.at(-1) || '';
    if (!handle || /%2f|%5c/i.test(handle) || /\.(?:js|json|oembed|atom)$/i.test(handle)) return false;
    return (segments.length === 2 && segments[0] === 'products') ||
      (segments.length === 4 && segments[0] === 'collections' && segments[1] && segments[2] === 'products');
  };

  const excluded = [
    'form', 'product-form', 'cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification',
    '.shopify-payment-button', 'shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart',
  ].join(', ');

  const updateLink = (link) => {
    if (!link || link.tagName !== 'A' || link.hasAttribute('download') || link.closest(excluded)) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin ||
      !isProductPath(url.pathname) || url.searchParams.has('country')) return;
    link.setAttribute('href', `${url.pathname}${url.search}${url.search ? '&' : '?'}country=${country}${url.hash}`);
  };

  const updateTree = (root) => {
    if (!root || root.nodeType !== 1) return;
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  };

  const initialize = () => {
    updateTree(document.documentElement);
    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach(updateTree));
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || (typeof event.button === 'number' && event.button !== 0)) return;
    updateLink(event.target?.closest?.('a[href]'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
